var map = {
	"./bat-dong-san.png": "74a7",
	"./chan-nuoi.png": "e6f7",
	"./cong-nghe.png": "2d6c",
	"./content-ecosystem-mobile.png": "b4b4",
	"./content-ecosystem.png": "85c0",
	"./dinh-gia-doanh-nghiep.png": "146b",
	"./giai-phap-goi-von.png": "f7cd",
	"./invest.png": "cf12",
	"./phap-ly-doanh-nghiep.png": "08d1",
	"./repre.png": "4b72",
	"./tai-cau-truc.png": "d8a7",
	"./tai-chinh-doanh-nghiep.png": "2410",
	"./tham-my-vien.png": "1c9a",
	"./xay-dung-va-phat-trien.png": "d42e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "389f";